<template>
  <div class="view post" v-if="post">
    <div class="wrapper">
      <div class="page-title">
        <h1>News</h1>
      </div>
    </div>
    <div class="post-container">
      <div class="post-image">
        <svg v-if="postImage" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1181.657" height="619.649" viewBox="0 0 1181.657 619.649"><defs><pattern id="a" preserveAspectRatio="xMidYMid slice" width="100%" height="100%"><image :width="postImage.width" :height="postImage.height" :transform="`translate(0 ${postImage.y})`" :xlink:href="post.image"/></pattern><filter id="b" x="0" y="0" width="1181.657" height="619.649" filterUnits="userSpaceOnUse"><feOffset dy="14" input="SourceAlpha"/><feGaussianBlur stdDeviation="14" result="c"/><feFlood flood-opacity="0.059"/><feComposite operator="in" in2="c"/><feComposite in="SourceGraphic"/></filter></defs><g transform="matrix(1, 0, 0, 1, 0, 0)" filter="url(#b)"><path d="M130.728,132.338C319.6,25.83,560.1-55.457,792.166,68.15S1115.5,392.954,958.1,483.126,285.661,552.785,65.556,465.056-58.139,238.845,130.728,132.338Z" transform="translate(103.01 22.07)" fill="url(#a)"/></g></svg>
      </div>
      <div class="post-info"><span>{{post.author.name}} - <DateFormat format="%lm %d, %Y" :date="post.date.toDate()" /></span><h1 class="post-title">{{post.title}}</h1></div>
      <div class="post-wrapper">
        <div :position="sharePosition" class="post-share" ref="share">
          <router-link to="/news"><i class="fas fa-home"></i></router-link>
          <a :href="postLink" ref="sidebar" :title="post.title" @click="bookmark"><i class="far fa-bookmark"></i></a>
          <a :href="`https://www.facebook.com/sharer/sharer.php?u=${postLink}`" target="_blank"><i class="fab fa-facebook"></i></a>
          <a :href="`https://twitter.com/intent/tweet?text=${post.title} ${postLink}`" target="_blank"><i class="fab fa-twitter"></i></a>
          <a :href="`https://www.linkedin.com/shareArticle?mini=true&url=${postLink}&title=${post.title}`" target="_blank"><i class="fab fa-linkedin-in"></i></a>
          <a class="clip" ref="clipLink" :data-clipboard-text="postLink"><i class="fas fa-link"></i></a>
        </div>
        <div ref="content" class="post-content" v-html="post.content"></div>
      </div>
    </div>
    <div class="more" v-if="posts.length">
      <div class="wrapper">
        <h2>More stories</h2>
        <div class="posts">
          <NewsItem :post="post" class="post" v-for="post in posts" :key="post.id" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import DateFormat from '../components/DateFormat'
import NewsItem from '../components/NewsItem'
import Clipboard from 'clipboard'

export default {
  name: 'post',
  computed: {
    ...mapGetters({
      'db': 'getDb',
      isMobile: 'getMobile'
    }),
    postId() {
      return this.$route.params.id
    },
    postLink() {
      return `https://cast-9c28d.firebaseapp.com/n/${this.post ? this.post.id : ''}` + (window.location.href.includes('castnetwork.eu') ? '?p=1' : '')
    },
  },
  components: {
    DateFormat,
    NewsItem
  },
  watch: {
    postId(id) {
      this.getPost(id)
    },
    post(p) {
      if(this.newsRef) this.newsRef()
      if(p) {
        this.newsRef = this.db().collection('posts').orderBy('date', 'desc').limit(4).onSnapshot(posts => {
          this.posts = posts.docs.filter(doc => doc.id !== p.id).map(doc => doc.data()).slice(0, 3)
        })
      }
    }
  },
  methods: {
    getPost(id) {
      if(this.postRef) this.postRef()
      if(id) {
        this.postRef = this.db().collection('posts').doc(id).onSnapshot(post => {
          this.post = post.exists ? post.data() : null
          if(post.exists) {
            this.$nextTick(() => {
              const img = new Image()
              img.onload = () => {
                const width = 1182
                const ratio = width / img.width
                const height = img.height * ratio
                const y = (680 - height) / 2
                this.postImage = {width, height, y}
                this.$store.commit('setPageLoading', false)
              }
              img.onerror = () => this.postImage = null
              img.src = this.post.image
              const cp = new Clipboard(this.$refs.clipLink)
              cp.on('success', () => {
                this.$refs.clipLink.classList.add('copied')
                setTimeout(() => this.$refs.clipLink.classList.remove('copied'), 3000)
              })
            })
          }
          else this.$store.commit('setPageLoading', false)
        })
      }
    },
    bookmark(e) {
      if ('addToHomescreen' in window && window.addToHomescreen.isCompatible) {
        window.addToHomescreen({ autostart: false, startDelay: 0 }).show(true)
      } else if (window.sidebar && window.sidebar.addPanel) {
        window.sidebar.addPanel(this.post.title, this.postLink, '')
      } else if ((window.sidebar && /Firefox/i.test(navigator.userAgent)) || (window.opera && window.print)) {
        return true
      } else if (window.external && ('AddFavorite' in window.external)) {
        window.external.AddFavorite(this.postLink, this.post.title)
      } else {
        alert('Press ' + (/Mac/i.test(navigator.platform) ? 'Cmd' : 'Ctrl') + '+D to bookmark this page.')
      }
      e.preventDefault()
      return false
    }
  },
  data() {
    return {
      post: null,
      posts: [],
      postImage: null,
      sharePosition: 'before'
    }
  },
  mounted: function() {
    this.getPost(this.postId)
    window.addEventListener('scroll', () => {
      if(this.post && this.$refs.share && this.$refs.content) {
        const pos = this.$refs.share.getBoundingClientRect()
        const content = this.$refs.content.getBoundingClientRect()
        let y = -(content.top - 140)
        const limit = content.height - pos.height - 20
        if(content.top > 140 || window.innerWidth <= 650) y = 0
        else if(limit < y) y = limit
        this.$refs.share.style.transform = `translateY(${y}px)`
      }
    })
  },
  beforeDestroy: function() {
    if(this.postRef) this.postRef()
  }
}
</script>

<style scoped>
.view {
  background: url(../assets/cast_news_banner.svg) no-repeat top center/1920px auto;
  padding-top: 222px;
}

.page-title {
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 202px;
}

.page-title h1 {
  font: bold 3.21em/1 'Butler';
  padding-top: 12px;
}

.page-title p {
  position: relative;
  margin-left: 196px;
  width: 358px;
}

.page-title p:before {
  content: '';
  position: absolute;
  display: block;
  top: 0;
  left: -136px;
  bottom: 0;
  width: 60px;
  height: 1px;
  margin: auto;
  background: #F77E0B;
}

.post-container .post-image {
  display: block;
  width: 1182px;
  max-width: 100%;
  margin: -120px auto 38px;
}

.post-container .post-image svg {
  display: block;
  width: 100%;
}

.post-container .post-info,
.post-container .post-title,
.post-container .post-wrapper {
  width: 800px;
  margin: auto;
  max-width: 100%;
}

.post-container .post-title {
  font: bold 4.43em/.84 'Butler';
  padding-right: 165px;
  margin-top: 20px;
}

.post-container .post-info {
  position: relative;
}

.post-container .post-info > span {
  font-size: .72em;
  letter-spacing: .58em;
  font-weight: 300;
  text-transform: uppercase;
  opacity: .77;
}

.post-container .post-content {
  font-size: 1.42em;
  font-weight: 300;
  line-height: 2;
  margin-top: 30px;
}

.post-container .post-content >>> img {
  display: block;
  width: 1072px;
  margin: 30px 0 30px -136px;
  max-width: 100vw;
}

.post-container .post-content >>> ul {
  list-style:disc;
  padding-left: 24px;
  margin-left: 24px;
}

.post-wrapper {
  position: relative;
}

.post-share {
  position: absolute;
  top: 14px;
  left: -96px;
  width: 42px;
  background: #fff;
  border: 1px solid rgba(188, 188, 203, 0.23);
  border-radius: 21px;
  text-align: center;
  padding: 11px 0;
}

.post-share a {
  display: block;
  color: #BCBCCB;
  font-size: 1.14em;
  line-height: 1;
  padding: 11px 0;
  transition: color .16s;
}

.post-share a.clip {
  position: relative;
}

.post-share a.clip:before,
.post-share a.clip:after {
  content: '';
  position: absolute;
  height: 2px;
  background: currentColor;
  width: 0;
  opacity: 0;
  transition: opacity .16s;
}

.post-share a.clip.copied:before,
.post-share a.clip.copied:after {
  opacity: 1;
  transition: width .16s;
}

.post-share a.clip:before {
  left: 28%;
  top: 53%;
  transform: rotateZ(45deg);
  transform-origin: right bottom;
}

.post-share a.clip:after {
  left: 47%;
  top: 55%;
  transform: rotateZ(-45deg);
  transform-origin: left bottom;
}

.post-share a.clip.copied:before {
  width: 17%;
}

.post-share a.clip.copied:after {
  width: 35%;
  transition-delay: .16s;
}

.post-share a.clip i {
  transition: opacity .16s;
  transition-delay: .16s;
}

.post-share a.clip.copied i {
  opacity: 0;
  transition-delay: 0s;
}

@media screen and (min-width: 1025px) {
  .post-share a:hover {
    color: #F77E0B;
  }
}

.more {
  margin-top: 120px;
  background: rgb(247,247,247);
  background: -moz-linear-gradient(0deg, rgba(247,247,247,0.5046393557422969) 0%, rgba(247,247,247,0) 100%);
  background: -webkit-linear-gradient(0deg, rgba(247,247,247,0.5046393557422969) 0%, rgba(247,247,247,0) 100%);
  background: linear-gradient(0deg, rgba(247,247,247,0.5046393557422969) 0%, rgba(247,247,247,0) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#f7f7f7",endColorstr="#f7f7f7",GradientType=1);
}

.more h2 {
  font: bold 3.21em/1 'Butler';
  text-align: center;
  color: #F77E0B;
}

.posts {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  margin-bottom: 64px;
}

.posts .post {
  width: 33.333333%;
  text-align: center;
  margin-top: 80px;
}

@media screen and (max-width: 1170px) {
  .post-container {
    padding-left: 148px;
  }
}

@media screen and (max-width: 1024px) {
  .view {
    background: none;
    padding-top: 180px;
  }
  .page-title {
    display: none;
  }
  .post-container {
    padding-right: 24px;
  }
  .post-container .post-image {
    width: auto;
    max-width: none;
    margin: 0 -24px 0 -148px;
  }
  .post-container .post-image svg {
    height: auto;
  }
  .post-container .post-content {
    font-size: 18px;
    line-height: 1.77;
  }
  .post-container .post-title {
    font-size: 48px;
    padding: 0;
  }
  .more h2 {
    font-size: 28px;
  }
  .posts .post {
    margin-top: 48px;
  }
  .posts .post .post-title {
    padding: 0;
  }
}

@media screen and (max-width: 920px) {
  .posts .post {
    width: 50%;
  }
  .posts .post:nth-child(3) {
    display: none;
  }
}

@media screen and (max-width: 680px) {
  .view {
    padding-top: 172px;
  }
}

@media screen and (max-width: 650px) {
  .post-container {
    padding-left: 24px;
  }
  .post-share {
    display: flex;
    left: 0;
    right: 0;
    top: 100%;
    width: 246px;
    height: 42px;
    padding: 0 11px;
    margin: 24px auto 0;
  }
  .post-share a {
    flex-grow: 1;
    padding: 0;
    line-height: 40px;
  }
  .post-container .post-content {
    margin-top: 48px;
  }
  .post-container .post-image {
    margin: 0 -24px 24px;
  }
  .post-container .post-title {
    font-size: 32px;
  }
  .more {
    margin-top: 148px;
  }
  .posts .post {
    width: 100%;
  }
  .posts .post:nth-child(2) {
    display: none;
  }
}
</style>

